import { render, staticRenderFns } from "./SectionsTable.vue?vue&type=template&id=40169f4a"
import script from "./SectionsTable.vue?vue&type=script&lang=js"
export * from "./SectionsTable.vue?vue&type=script&lang=js"
import style0 from "./SectionsTable.vue?vue&type=style&index=0&id=40169f4a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports